<template>
    <group-details :groupId="props.groupId">
        <div class="vx-col-span-12 lg:vx-col-span-6">
            <page-header class="vx-mb-2 md:vx-mb-2">Collections</page-header>

            <div v-if="loading && !list.length" class="vx-text-center vx-py-10">
                <vx-icon-loading class="vx-w-9 vx-h-9 vx-animate-loading-spin"></vx-icon-loading>
            </div>

            <template v-else-if="!loading && list.length === 0">
                <vx-box color="info" class="vx-mt-4 vx-flex vx-flex-col vx-px-8 vx-py-20 vx-gap-6 vx-items-center vx-text-xl vx-text-slate-500">
                    No collections yet.
                </vx-box>
            </template>
            <template v-else>
                <vx-table v-if="list.length" class="xl:vx-grid-cols-2 vx-mt-0" rowBreakpoint="xl">
                    <vx-table-row isHeader>
                        <div class="xl:vx-col-span-2">
                            Name
                        </div>
                    </vx-table-row>
                    <group-collection-row v-for="(item, index) in list"
                        v-model="list[index]"
                        :key="item.id"></group-collection-row>
                </vx-table>
            </template>
        </div>
    </group-details>
</template>

<script setup>
import GroupDetails from '../GroupDetails.vue';
import { VxBox, VxIconLoading, VxTable, VxTableRow } from '@voxie/frontend-components';
import PageHeader from '~/components/general/PageHeader.vue';
import GroupCollectionRow from './GroupCollectionRow.vue';
import { useCursorPagination } from '~/composables/useCursorPagination';
import groupsClient from '~/services/groupsClient';
import { onMounted } from 'vue';

const teamId = Spark.state.currentTeam.id;
const { list, loading, fetchRecords } = useCursorPagination();

const props = defineProps({
    groupId: {
        type: String,
        required: true,
    },
});

onMounted(() => {
    fetchRecords(groupsClient.getGroupCollections(teamId, props.groupId));
});
</script>
